<ng-container [formGroup]="parentForm">
  <div
    [formArrayName]="index"
    [ngClass]="{ 'column-break-before': isColumnBreakBefore }"
    class="checkbox-container avoid-column-break"
  >
    <div class="item-padding flex flex-start-center">
      @if (isLeaf()) {
        <div>
          <button
            [disableRipple]="true"
            (click)="toggleSubcategories()"
            class="tree-toggle-button"
            mat-icon-button
            matTreeNodeToggle
            type="button"
          >
            <mat-icon
              [ngClass]="{ 'tree-btn-icon-closed': !showSubcategories }"
              class="mat-icon-rtl-mirror"
              color="primary"
              svgIcon="{{ icon }}"
            ></mat-icon>
          </button>
        </div>
      }
      <div [ngClass]="{ leaf: !isLeaf(), flat: isFlat }">
        <mat-checkbox
          [id]="idAttributeGenerate(data)"
          (change)="onCheckboxValueChange()"
          color="primary"
          formControlName="checkbox"
        >
          {{ data.Name }}
        </mat-checkbox>
      </div>
    </div>

    @if (showSubcategories && branch.subcategories) {
      <div class="subcategory">
        @for (subControl of branch.subcategories.controls; track subControl; let j = $index) {
          <checkbox-category
            [branch]="subControl['controls']"
            [data]="data.Subcategories[j]"
            [index]="j"
            [instance]="instance"
            [name]="name"
            [parentForm]="branch.subcategories"
          ></checkbox-category>
        }
      </div>
    }
  </div>
</ng-container>
